import { React, useState, useEffect } from "react";

import { useLocation, useParams } from "react-router-dom";

import { getClass, getStudents } from "../services/APIClient";

import HeadingBanner from "../components/HeadingBanner";
import LeftPanel from "../components/LeftPanel";
import AllStudentResultsOverview from "../components/AllStudentResultsOverview";
import OrientationPrompt from "../components/OrientationPrompt";

import { Container, Row, Col } from "react-bootstrap";

function AllStudentResults(props) {
  const location = useLocation();
  console.log("Location:", location);
  let name = "Results";

  let classDetails = location.state.classDetails;
  let classid = location.state.classDetails.id;

  let gradeLevel = location.state.gradeLevel;
  let classAssessments = location.state.classAssessments;
  // let teacherid = location.state.classDetails.classDetails.teacherId;
  let teachers = location.state.teachers;
  let assessment = location.state.assessment;
  let studentResults = location.state.studentResults;
  let rawStudentResults = location.state.rawStudentResults;
  let studentResultsForHistory = location.state?.studentResultsForHistory;


  console.log("AllStudentResults studentResults:", studentResults);
  console.log("AllStudentResults rawStudentResults:", rawStudentResults);

  let taskNameArray = location.state.taskNameArray;
  let assessmentResultsByStudent = location.state.assessmentResultsByStudent;
  let toggleScoreType = location.state.toggleScoreType;

  let schoolid = location.state?.schoolid;
  let teacherid = location.state?.teacherid;
  let students = location.state?.students;
  let viewParent = location.state?.viewParent;
  let viewTeacher = location.state?.viewTeacher;
  let fromSencoResults = location.state?.fromSencoResults;
  let readingScores = location.state?.readingScores;

  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );

  // useEffect(() => {
  //   window.HubSpotConversations?.widget?.refresh();
  // }, []);

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  // useEffect(() => {
  //   window.HubSpotConversations?.widget?.refresh();
  // }, []);

  return (
    <Container fluid className="vh-100">
      <HeadingBanner
        name={name}
        isLoggedIn={true}
        cloud={true}
        teacherid={teacherid}
      />
      <Row className="h-100">
        <LeftPanel />
        <Col sm={{ span: 10, offset: 2 }} className="blue-background">
          <AllStudentResultsOverview
            classDetails={classDetails}
            classAssessments={classAssessments}
            // teachers={location.state.teachers}
            // sharedWith={sharedWith}
            students={students}
            gradeLevel={gradeLevel}
            teachers={teachers}
            assessment={assessment}
            studentResults={studentResults}
            rawStudentResults={rawStudentResults}
            studentResultsForHistory={studentResultsForHistory}
            taskNameArray={taskNameArray}
            assessmentResultsByStudent={assessmentResultsByStudent}
            toggleScoreType={toggleScoreType}
            schoolid={schoolid}
            teacherid={teacherid}
            viewParent={viewParent}
            viewTeacher={viewTeacher}
            fromSencoResults={fromSencoResults}
            readingScores={readingScores}
          />
        </Col>
      </Row>
      {isPortrait && <OrientationPrompt />}
    </Container>
  );
}

export default AllStudentResults;
